<template>

		<form ref="form" @submit.prevent="confirm()">

			<div class="header">
				<b-row>
					<b-col md="6" order="2" order-sm="1" :title="sale.optional ? 'opc' : ''">
						<h2>{{translation.sale.title}}, {{chargingLink.name}}.</h2>
						<h6>{{translation.sale.subtitle}}</h6>
					</b-col>
					<b-col md="6" order="1" order-sm="2"><img :src="getLogoUrl(chargingLink)" class="logo" alt=""></b-col>
				</b-row>
			</div>

			<div class="form-top">
				<b-row>
					<b-col md="7">
						<b-row>
							<b-col md="4"><labeled-input type="decimal" id="amount" :value="sale.amount" prepend="R$" :label="translation.sale.amount" size="sm" autocomplete="off" :disabled="true"/></b-col>
							<b-col md="4"><labeled-input id="file" :value="sale.fileNumber" :disabled="true" :label="translation.sale.file" size="sm"/></b-col>
							<b-col md="4"><labeled-input id="linkExpirationDate" :value="chargingLink.expirationDate" :label="translation.sale.linkExpirationDate" size="sm" :disabled="true" /></b-col>
						</b-row>
						<b-row>
							<b-col md="4"><labeled-input id="cardNumber" v-model="sale.creditCard.cardNumber" :label="translation.sale.cardNumber" :mask="brand.mask" size="sm" @change="parseCardNumberIntoBrand" required /></b-col>
							<b-col md="4"><labeled-input id="holder" v-model="holder" :label="translation.sale.holder" size="sm" required /></b-col>
							<b-col md="2"><labeled-input id="securityCode" v-model="sale.creditCard.securityCode" :label="translation.sale.securityCode" mask="9999" size="sm" required /></b-col>
							<b-col md="2"><labeled-input id="expirationDate" v-model="sale.creditCard.expirationDate" :label="translation.sale.dueDate" mask="99/99" size="sm" required /></b-col>
						</b-row>
						<b-row>
							<b-col md="4">
								<labeled-input class="brand" :label="translation.sale.brand">
									<multiselect v-model="brand" :options="brands" track-by="type"
										:show-labels="false" placeholder="Bandeira"
									>
										<template #singleLabel="{option}">
											<img height="20" :src="option.image">
										</template>
										<template #option="{option}">
											<img height="20" :src="option.image">
										</template>
									</multiselect>
								</labeled-input>
							</b-col>
							<b-col md="4">
								<labeled-input type="select" id="installments" v-model="sale.installments" :label="translation.sale.installments" :options="installments" size="sm" required />
							</b-col>
						</b-row>
						<b-row>
						<labeled-input v-if="chargingLink.useFraudAnalysis" class="col-sm-3" v-model="sale.customer.phone"
						:label="translation.sale.phone" size="sm" required/>
						<labeled-input v-if="chargingLink.useFraudAnalysis" class="col" v-model="sale.customer.email" @blur="validateEmail()"
						:label="translation.sale.email" size="sm" required/>
						<labeled-input v-if="chargingLink.useFraudAnalysis" class="col-sm-4" v-model="sale.customer.birthDate" @blur="validateBirthDate()"
						:placeholder="translation.sale.datePlaceholder" :label="translation.sale.birthDate" mask="99/99/9999" size="sm" required/>
					</b-row>
						<b-row><b-col></b-col></b-row>
					</b-col>

					<b-col md="5">
						<credit-card :creditCard="sale.creditCard" :type="brand" :language="chargingLink.language" />
					</b-col>
				</b-row>

			</div>

			<div class="form-bottom">
	      <b-row>
	        <b-col md="3" v-if="isBrazil()">
	          <labeled-input id="inscriptionTypeIdentity" :label="translation.sale.inscription">
	            <b-form-select id="inscriptionType" v-model="inscriptionType" :options="inscriptionTypes" size="sm" required />
	            <b-form-input id="identity" v-model="sale.customer.inscription" v-mask="inscriptionType.mask" size="sm" required />
	          </labeled-input>
	        </b-col>
	        <b-col md="2">
	          <labeled-input id="zip" v-model="sale.customer.address.zipCode" :label="translation.sale.zipCode" :mask="isBrazil ? translation.sale.zipCodeMask : null" @blur="fillAddressFieldsOnValidCep" size="sm" required />
	        </b-col>
	        <b-col>
	          <labeled-input id="street" v-model="sale.customer.address.street" :label="translation.sale.address" size="sm" required />
	        </b-col>
	        <b-col md="1">
	          <labeled-input id="number" v-model="sale.customer.address.number" :label="translation.sale.number" size="sm" required />
	        </b-col>
	        <b-col md="2">
	          <labeled-input id="complement" v-model="sale.customer.address.complement" :label="translation.sale.complement" size="sm"/>
	        </b-col>
	      </b-row>
	      <b-row>
	        <b-col md="3">
	          <labeled-input id="district" v-model="sale.customer.address.district" :label="translation.sale.district" size="sm" required />
	        </b-col>
	        <b-col md="3">
	          <labeled-input id="city" v-model="sale.customer.address.city" :label="translation.sale.city" size="sm" required />
	        </b-col>
	        <b-col md="3">
	          <labeled-input id="state" v-model="sale.customer.address.state" :label="translation.sale.state" size="sm" required />
	        </b-col>
					<b-col md="1">
	          <labeled-input id="uf" v-model="sale.customer.address.uf" :label="translation.sale.uf" size="sm" maxLength="2" required />
	        </b-col>
	        <b-col md="2">
	          <labeled-input id="country" :value="chargingLink.country.name" :label="translation.sale.country" size="sm" disabled />
	        </b-col>
	      </b-row>
			</div>
			<div>
				<b-row>
					<b-col cols="12" sm="4">
						<b-form-checkbox class="general-conditions" name="generalConditions" required> {{ translation.sale.terms }}<a href="" @click.prevent="isOpen = true">{{ translation.sale.termsLink }}</a>. </b-form-checkbox>
					</b-col>
					<b-col class="align-self-center">
						<b-button id="confirm" type="submit" :disabled="loading">{{buttonLabel}}</b-button>
					</b-col>
				</b-row>
			</div>
			<b-modal :title="translation.sale.termsLink.charAt(0).toUpperCase() + translation.sale.termsLink.substring(1)" v-model="isOpen" hide-footer size="xl">
				<span v-html="generalConditions"></span>
			</b-modal>
		</form>



</template>

<script>
import AwesomeMask from 'awesome-mask';
import { InscriptionType } from '../../enums/InscriptionType';
import { FraudAnalysisStatus } from '../../enums/FraudAnalysisStatus';
import { SaleStatus } from '../../enums/SaleStatus';
import Language from '../../enums/Language';
import CreditCard from './CreditCard';
import creditCardType from 'credit-card-type';
import cardTypes from 'credit-card-type/lib/card-types';
import { getLogoUrl, viaCep } from '../../utils';
import PaymentWebservice from '../../services/PaymentWebservice';
import { mapActions } from 'vuex';
import moment from 'moment';
import emailValidator from 'email-validator';
import { translate } from '../../assets/translations';
import BlumarConfig from '../../blumar-config';
import { CreditCardBrand } from '../../enums/CreditCardBrand';

let mask = '9999 9999 9999 9999';

const defaultBrand = () => ({ mask, image: '', brand: {} });

creditCardType.changeOrder('elo', 0);

export default {
	components: { CreditCard },
	directives: { mask: AwesomeMask },
	props: ['sale', 'chargingLink'],
	data() {
		return {
			paymentWebservice: new PaymentWebservice(),
			inscriptionTypes: [
				{ text: InscriptionType.CPF.name, value: InscriptionType.CPF },
				{ text: InscriptionType.CNPJ.name, value: InscriptionType.CNPJ }
			],
			inscriptionType: InscriptionType.CPF,
			installments: [],
			brand: defaultBrand(),
			brands: Object.keys(cardTypes).filter(key => CreditCardBrand[key]).map(key => ({
				...cardTypes[key],
				...CreditCardBrand[key] || {}
			})),
			loading: false,
			isOpen: false,
		};
	},
	computed: {
    translation() {
      return translate(this.chargingLink.language);
    },
		holder: {
			get() {
				return this.sale.creditCard.holder;
			},
			set(value) {
				this.sale.creditCard.holder = value.toUpperCase();
			}
		},
		buttonLabel() {
			if(this.loading)
				return this.translation.sale.loading;
			return this.translation.sale.confirm;
		},
		generalConditions() {
			return this.translation.sale.generalConditions
			.replace(/{companyName}/g, this.chargingLink.company.name)
			.replace(/{companyCnpj}/g, this.chargingLink.company.cnpj)
			.replace(/{companyAddress}/g, this.chargingLink.company.addressStreet + ' - ' + this.chargingLink.company.addressZipCode + ' - ' + this.chargingLink.company.addressDistrict + ' - ' + this.chargingLink.company.addressCity + ' - ' + this.chargingLink.company.addressCountry)
		}
	},
	watch: {
		brand() {
			this.loadInstallments();
		}
	},
	methods: {
		...mapActions(['showAlert']),
		getLogoUrl,
		isBrazil() {
			return this.chargingLink.country.id === BlumarConfig.brazilCountryId;
		},
		parseCardNumberIntoBrand() {
			let cardNumber = this.sale.cardNumber;
			let types = [];

			if (cardNumber !== '')
				types = creditCardType(this.sale.creditCard.cardNumber.match(/\d+/g).join('')).filter(type => CreditCardBrand[type.type]);

			if (types.length > 0)
				return this.brand = {
					...types[0],
					...CreditCardBrand[types[0].type] || {}
				};
		},
		loadInstallments() {
			if(this.brand && this.brand.brand && this.brand.brand.id) {
				var maxInstallments = this.chargingLink.maxInstallments.find(maxInstallment => maxInstallment.brand.id == this.brand.brand.id);
				var maxInstallment = maxInstallments ? maxInstallments.value : 1;
				this.installments = Array.from({length: maxInstallment}, (_, i) => i + 1);
			}
		},
		async fillAddressFieldsOnValidCep() {
			let cep = this.sale.customer.address.zipCode;
			const CEP_LENGTH = 8;
			cep = cep.replace('-', '');
			if (cep.length === CEP_LENGTH && this.isBrazil())
				this.fillAddressFields(cep);
		},
		async fillAddressFields(cep) {
			let address = await viaCep(cep);
			if(address.erro)
				return this.warn("CEP não encontrado!");
			this.sale.customer.address.state = address.estado;
			this.sale.customer.address.uf = address.uf;
			this.sale.customer.address.city = address.localidade;
			this.sale.customer.address.street = address.logradouro;
			this.sale.customer.address.district = address.bairro;
		},
		async confirm() {
			if(!this.brand || !this.brand.brand || !this.brand.brand.id) {
				this.showAlert({style: 'warning', code: 0, message: this.translation.sale.brandIsMandatory});
				return;
			}
			this.sale.creditCard.brandId = this.brand.brand.id;
			this.sale.customer.inscriptionTypeId = this.inscriptionType.id;
			this.createSale(this.requestAuthorization);
		},
		async requestAuthorization(sale) {
			let {data} = await this.paymentWebservice.authorize(sale);
			return data;
		},
		async createSale(request) {
			try {
				this.loading = true;
				let sale = this.prepareSale();
				let saleResponse = await request(sale);
  			this.validateSaleResponse(saleResponse);
			} catch (err) {
				if (err.response)
					this.showAlert({style: 'danger', code: 0, message: err.response.data.message});
				else if (err.notify)
					err.notify();
				else
					console.error(err);
			} finally {
				this.loading = false;
			}
    },
		prepareSale() {
			let sale = JSON.parse(JSON.stringify(this.sale));
			sale.exchange = this.chargingLink.exchange;
			sale.creditCard.cardNumber = sale.creditCard.cardNumber.match(/\d+/g).join('');

			this.handleExpirationDate(sale);

			sale.customer.inscription = sale.customer.inscription
				? sale.customer.inscription.replace(/[^0-9A-Za-z]/g, "")
				: undefined;

			return sale;
		},
		handleExpirationDate(sale) {
			let expirationDate = sale.creditCard.expirationDate;
			sale.creditCard.expirationDate = moment(expirationDate, 'MM/YY').format('MM/YYYY');
		},
		validateSaleResponse(saleResponse) {
			let { returnCode, integrationError } = saleResponse;
			console.log("returnCode: ", returnCode);
			console.log("integrationError: ", integrationError);

			if (saleResponse.antifraudStatus && saleResponse.antifraudStatus.id === FraudAnalysisStatus.REJECT.id)
        return this.sendToFeedbackPageWithRetry(this.translation.sale.rejectedByAntifraud);

			if (saleResponse.antifraudStatus && saleResponse.antifraudStatus.id === FraudAnalysisStatus.ABORTED.id)
        return this.sendToFeedbackPage(this.translation.sale.paymentAborted);

      if (saleResponse.saleStatus.id === SaleStatus.AUTHORIZED.id)
        return this.sendToFeedbackPage(this.translation.sale.paymentConfirmed);

      if (saleResponse.saleStatus.id === SaleStatus.PRE_AUTHORIZED.id) {
        if (saleResponse.antifraudStatus && saleResponse.antifraudStatus.id === FraudAnalysisStatus.REVIEW.id)
          return this.sendToFeedbackPage(this.translation.sale.reviewingPayment);
      }

      if (saleResponse.saleStatus.id === SaleStatus.NOT_AUTHORIZED.id) {
        return this.sendToFeedbackPageWithRetry(this.translation.sale.paymentNotConfirmed);
      }

      if (saleResponse.saleStatus.id === SaleStatus.NONE.id || saleResponse.saleStatus.id === SaleStatus.CANCELED.id) {
        return this.sendToFeedbackPageWithRetry(this.translation.sale.paymentNotMadeTryLater);
      }

      if (saleResponse.saleStatus.id === SaleStatus.PENDING.id) {
        return this.sendToFeedbackPage(this.translation.sale.reviewingPayment);
      }

			if (integrationError)
				throw { notify: () => {
					this.showAlert({style: 'danger', code: 0, message: this.translation.sale.integrationError});
					console.error(`CreditCard Integration Http Reponse[${integrationError.code}]: ${integrationError.description}`);
					this.$emit('failure', saleResponse);
				}};

			throw { notify: () => {
				this.showAlert({style: 'danger', code: 0, message: this.translation.sale.unknownError});
				this.$emit('failure', saleResponse);
			}};
		},
    sendToFeedbackPageWithRetry(message) {
      return this.sendToFeedbackPage(message, true);
    },
    sendToFeedbackPage(message, retry = false) {
      this.$router.push({
        name: 'charging-feedback',
        params: {
          message,
          sale: this.sale,
					charging: this.chargingLink,
          retry
        }
      });
    },
		warn(message) {
			this.$store.dispatch('showAlert', {style: 'warning', code: 0, message});
			return false;
		},
		validateBirthDate() {
			if(!moment(this.sale.customer.birthDate, 'DD/MM/YYYY').isValid())
				this.sale.customer.birthDate = "";
		},
		validateEmail() {
			if(!emailValidator.validate(this.sale.customer.email))
				this.sale.customer.email = "";
		},
	}
}
</script>

<style scoped lang="scss">

form {
	background: white;
	padding: 25px;
	border-radius: 20px;
	overflow: auto;
}

.form-top {
	margin: 20px 0;
}

.form-bottom {
	margin: 20px 0;
}

#inscriptionType {
	max-width: 80px;
}

.footer {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

#confirm {
	float: right;
}

#confirm:disabled {
	cursor: not-allowed;
}

.header {
	margin-bottom: 50px;
}

.logo {
	height: 60px;
	float: right;
	margin-bottom: 10px;
}

.brand .invalid >>> .multiselect__tags {
	border-color: red;
}

.general-conditions {
	margin-bottom: 10px;
}
</style>
<style>
	.bold {
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/Charging.vue